<template>
  <div :class="containerClass" v-if="loading">
    <SkeletonLoader />
    <SkeletonLoader />
  </div>
  <div v-else>
    <div v-if="agentsDetails">
      <div :class="containerClass">
        <a
          :href="
            $router.resolve({
              name: 'AgentView',
              params: {
                id: agent.id,
                slug: $sanitizeTitle(agent.name),
              },
            }).href
          "
          v-for="agent in agentsDetails.data"
          :key="agent.id"
          class="relative flex flex-col border rounded-lg md:flex-row border-stone-200"
        >
          <div
            class="flex flex-col w-full md:flex-row md:items-start md:justify-start md:w-5/12"
          >
            <img
              :src="agent.photo ? agent.photo : `img/agent.jpg`"
              class="h-[220px] md:w-[220px] rounded-t-lg md:rounded-none md:rounded-l-lg"
              alt=""
            />
          </div>
          <div class="relative w-full md:flex md:w-7/12 md:justify-between">
            <div class="md:w-[386px] space-y-2 p-2">
              <h1 class="text-xl font-medium tracking-wide text-gray-700">
                {{ agent.name }}
              </h1>
              <p class="text-sm text-stone-500">{{ agent.specialization }}</p>
              <p class="text-sm text-stone-500">
                Nationality:
                <span
                  class="font-medium text-stone-700"
                  v-if="agent.nationality"
                  >{{ agent.nationality.citizenship }}</span
                >
              </p>
              <p class="text-sm text-stone-500">
                Languages:
                <span class="font-medium text-stone-700">{{
                  agent.languages
                }}</span>
              </p>
            </div>
            <div
              class="flex justify-between w-full px-3 py-3 space-x-2 md:px-0 md:pr-3 md:absolute md:bottom-0 md:left-0 border-stone-200"
            >
              <div
                class="md:w-[6rem] flex justify-center items-center md:h-6 rounded bg-[#F7F6FB] text-primary p-1"
              >
                <p class="text-[10px] font-semibold md:text-sm">
                  For Sale: {{ agent.properties_for_sale.length }}
                </p>
              </div>
              <div
                class="md:w-[6rem] flex justify-center items-center h-6 rounded bg-[#F7F6FB] text-primary p-1"
              >
                <p class="text-[10px] font-semibold md:text-sm">
                  For Rent: {{ agent.properties_for_rent.length }}
                </p>
              </div>
            </div>
            <img
              v-if="agent.company"
              :src="agent.company.photo"
              class="absolute top-0 right-0 hidden object-contain mr-2 rounded-lg md:flex w-14 h-14"
              alt=""
            />
          </div>
        </a>
      </div>

      <div
        class="flex items-center justify-center mt-8 mb-8"
        v-if="agentsDetails.data.length >= 20"
      >
        <button
          class="w-20 h-12 p-1 font-semibold text-white bg-secondary rounded-xl"
        >
          View All
        </button>
      </div>
      <div
        v-else-if="agentsDetails.data.length <= 0"
        class="md:w-[825px] mt-10 flex justify-center items-center"
      >
        <p class="text-xl text-stone-500">No agents</p>
      </div>
    </div>
  </div>
</template>
<script>
// import SuperAgents from "@/components/SuperAgent.vue";
import SkeletonLoader from "@/components/SkeletonLoader.vue";
export default {
  components: { SkeletonLoader },
  props: {
    agentsDetails: Object,
    isFullWidth: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: true,
    };
  },
  watch: {
    agentsDetails: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.data.length >= 0) {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        }
      },
    },
  },
  computed: {
    containerClass() {
      return this.isFullWidth ? "w-full space-y-4" : "grid grid-cols-2 gap-5";
    },
  },
};
</script>
